// extracted by mini-css-extract-plugin
export var falconContainer = "_vj-2";
export var offerCenter = "_vj-0";
export var roktContainer = "_vj-1";